<template>
  <div id="nav-bar-search-component" class="red-color d-flex align-items-center justify-content-center">
    <input
      class="pe-0 text-small w-25"
      type="text"
      aria-label="Search"
      :placeholder="placeholderSearch"
      v-model="textInput"
      @keyup.enter="clickedSearch"
      id="inputSearch">
    <div class="ps-1 pe-0">
      <select
        class="form-select text-small"
        id="search-select"
        v-model="searchTypeSelected">
        <option
          v-for="item in searchOptions"
          :key="item.type"
          :value="item.type">
          {{item['text']}}
        </option>
      </select>
    </div>
    <button
      class="border-0 text-small p-1 ms-1"
      type="submit"
      id="navBarSearchButton"
      :disabled="buttonDisabled"
      @click="clickedSearch">{{ buttonSearch }}</button>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

import { Watch } from 'vue-property-decorator'

import { useLanguageStore } from "@/stores/language";
import { usePhotoStore } from "@/stores/photo";
import { useCommonStore } from "@/stores/common" 
import { useCategoryStore } from "@/stores/category" 
import { useRouterStore } from "@/stores/router";

import {
  TEXT_KEYS,
  SEARCH_TYPE,
  STATUS_LOAD,
  LANGUAGE_LOADED_STATUS } from "@/constants";

@Options({
  components: {
  }
})
export default class NavBarSearch extends Vue {
  languageStore = useLanguageStore()
  photoStore = usePhotoStore()
  commonStore = useCommonStore()
  categoryStore = useCategoryStore()
  routerStore = useRouterStore()

  searchTypeSelected = SEARCH_TYPE.LARGE
  textInput = ''

  searchOptions = [] as  any

  STATUS_LOAD = STATUS_LOAD

  get placeholderSearch() {
    return this.languageStore.text(TEXT_KEYS.NAV_BAR_SEARCH_INPUT)
  }

  get buttonSearch() {
    return this.languageStore.text(TEXT_KEYS.NAV_BAR_SEARCH_SEARCH_BUTTON)
  }

  get photoPullStatus() {
    return this.photoStore.getStatus
  }

  get buttonDisabled() {
    return this.photoPullStatus === STATUS_LOAD.LOADING ||
      (this.textInput === '' && (this.photoPullStatus === STATUS_LOAD.LOADED || this.photoPullStatus === STATUS_LOAD.IDLE))
  }

  get languageLoadStatus() {
    return this.languageStore.getStatus
  }

  @Watch('languageLoadStatus')
  onlanguageLoadStatus(val: number, oldVal: number) {
    console.log("onlanguageLoadStatus", val, oldVal)

    if (val === LANGUAGE_LOADED_STATUS.LOADED) {
      this.populateSearchOptions()
    }
  }

  created() {
    this.$watch(() =>
      this.$route.params,
      (toParams: any, _: any) => {
        console.log("NavBarSearch", this.$route.params, toParams)

        if (('category_id' in this.$route.params || 'sub_category_id' in this.$route.params) && this.textInput !== '') {
          this.textInput = ''
        }
      }
    )
  }

  mounted() {
    console.log("mounted", SEARCH_TYPE.LARGE)

    if (this.languageLoadStatus === LANGUAGE_LOADED_STATUS.LOADED) {
      this.populateSearchOptions()

      this.searchTypeSelected = SEARCH_TYPE.LARGE
    }
  }

  public clickedSearch() {
    console.log("clickedSearch")

    const current_full_path = this.$router.currentRoute.value.fullPath

    const target_path = `/photos/search/${this.searchTypeSelected}?search_text=${this.textInput.toLowerCase()}`

    if (current_full_path !== target_path) {
      this.$router.push(target_path)
    } else {
      this.routerStore.incrementReloadIndex()
    }
  }

  private populateSearchOptions() {
    this.searchOptions = [{
      type: SEARCH_TYPE.LARGE,
      text: this.languageStore.text(TEXT_KEYS.NAV_BAR_SEARCH_SEARCH_LARGE)
    }, {
      type: SEARCH_TYPE.STRICT,
      text: this.languageStore.text(TEXT_KEYS.NAV_BAR_SEARCH_SEARCH_STRICT)
    }, {
      type: SEARCH_TYPE.STRICT_TITLE,
      text: this.languageStore.text(TEXT_KEYS.NAV_BAR_SEARCH_SEARCH_STRICT_TITLE)
    }, {
      type: SEARCH_TYPE.TITLE_START_WITH,
      text: this.languageStore.text(TEXT_KEYS.NAV_BAR_SEARCH_SEARCH_TITLE_START_WITH)
    }]
  }
}
</script>

<style lang="stylus">
#inputSearch, #search-select {
  width: 100%
  height: 2rem
}

#navBarSearchButton {
  height: 2rem
}
</style>
